import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-switch-lang';

class LoaderAbsolute extends Component {
  state = {
    enabled: false,
  }

  timer = null;

  componentDidMount() {
    this.timer = setTimeout(() => { this.setState({ enabled: true }); this.timer = null; }, 500);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  render() {
    const { t } = this.props;
    const { enabled } = this.state;
    return (
      enabled ? <div className="fullscreen-absolute">{t('Loading...')}</div> : null
    );
  }
}

LoaderAbsolute.propTypes = {};

export default translate(LoaderAbsolute);
